import { signal } from '@angular/core';
import { Message } from 'primeng/api';

export type ToastSeverity =
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'help'
  | 'primary'
  | 'secondary'
  | 'contrast'
  | undefined;

export interface ToastOptions extends Message {
  severity?: ToastSeverity;
  actions?: {
    label: string;
    command: (message: ToastOptions) => void;
  }[];
  data?: any;
}

export const toastSignal = signal<ToastOptions | undefined>(undefined);
export const toast = (message: ToastOptions) => toastSignal.set(message);
